import firebase from "firebase/app";
import "firebase/auth";
import { serverConfig } from "../constants";

firebase.initializeApp(serverConfig);

export const auth = firebase.auth();

export default firebase;
